import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 80rem;
  padding: 0rem 1.2rem;
  display: flex;
  justify-content: center;
`;
